/**
 * Application configuration
 * Central place for all configuration values
 */

// Site configuration
export const SITE_CONFIG = {
  NAME: "3Bay",
  DOMAIN: "3bay.eu",
  URL: "https://3bay.eu",
  CONTACT_EMAIL: "kontakt@3bay.eu",
  NO_REPLY_EMAIL: "no-reply@3bay.eu",
};

// API configuration
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL || `${SITE_CONFIG.URL}/api`,
  TIMEOUT: 30000, // 30 seconds timeout
};

// Pagination configuration
export const PAGINATION_CONFIG = {
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [5, 10, 25, 50],
};

// UI configuration
export const UI_CONFIG = {
  ANIMATION_DURATION: 300,
  DEBOUNCE_DELAY: 300,
  TOAST_DURATION: 5000,
};

export const SEARCH_CONFIG = {
  AUTOCOMPLETE_MIN_QUERY_LENGTH: 5,
  AUTOCOMPLETE_DEBOUNCE_DELAY: 300,
};

/**
 * Czas (w sekundach), po którym powiadomienie zamyka się automatycznie.
 * Ustaw `null`, aby wyłączyć auto-zamykanie.
 */
export const NOTIFICATION_AUTO_HIDE_DURATION_SECONDS = 6;

export const NOTIFICATION_AUTO_HIDE_DURATION_MS =
  NOTIFICATION_AUTO_HIDE_DURATION_SECONDS == null
    ? null
    : NOTIFICATION_AUTO_HIDE_DURATION_SECONDS * 1000;

// Feature flags
export const FEATURES = {
  ENABLE_CACHE: true,
};
